export const TeamCreateSceneTranslation = {
  fi: {
    TeamCreateScene: {
      inviteUser: 'Kutsu käyttäjä',
      allowFaultChannelOnly: 'Salli vain vikailmoituskanava',
    },
  },
};
